import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductLabelsModule } from '../product-labels/product-labels.module';
import { GetDisplayLabelInterfaceForConfirmationModalPipe } from './confirmation-modal/get-display-label-interface-for-condirmation-modal.pipe';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { SharedModule } from '../../views/shared/shared.module';
import { StickyModalModule } from '@mobilefirstdev/sticky-modal';
import { ReactiveButtonsModule } from '@mobilefirstdev/reactive-buttons';

@NgModule({
  imports: [
    CommonModule,
    ProductLabelsModule,
    FlexModule,
    MatExpansionModule,
    SharedModule,
    StickyModalModule,
    ReactiveButtonsModule
  ],
  declarations: [ConfirmationModalComponent, GetDisplayLabelInterfaceForConfirmationModalPipe],
  exports: []
})
export class ConfirmationModule {}
